import {EntityModel} from "@fedeltapointofsale/data-client";
import {SurchargeData} from "./surcharge.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SurchargeEntityModel extends EntityModel<SurchargeData> {
    constructor(injector: Injector) {
        super(injector, SurchargeData);
    }
}
